import React, {useEffect, useState} from 'react';
import {Button, Card, DatePicker, FloatButton, Form, Input, message, Modal, Select, Tabs} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import Cookies from "js-cookie";

const { RangePicker } = DatePicker;
const Project_vipcard = () => {

    document.title='优惠卡';

    const navigate=useNavigate();
    const data_time = dayjs().unix();


    useEffect(() => {


        setfetch_vipcard_list_select_log({message:'1',value:'',time:data_time})
    }, []);

    const [fetch_vipcard_list_select_info, setfetch_vipcard_list_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_vipcard_list_select_log, setfetch_vipcard_list_select_log] = useState({message: '', value: '', time: 0})
    const fetch_vipcard_list = (e1: any) => {

        setfetch_vipcard_list_select_log({message: 'click', value: '', time: data_time})



        setfetch_vipcard_list_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_vipcard_list,setreturn_data_fetch_vipcard_list]=useState({

        "message": 0,
        "value": "获取成功",
        "info": [
        {
            "id": "1",
            "uuid": "11",
            "useruuid": "90001",
            "name": "1月vip",
            "value": "30天vip",
            "vip_type": "fixed",
            "note": null,
            "vip_value": "5",
            "vipday": "30",
            "minimum_amount": "0",
            "key_cdk": "123",
            "created": null,
            "card_start_time": 0,
            "card_end_time": 0,
            "status": "en",
            "fetch_method": "系统发放",
            "status_type": "未使用",
            "is_select": "0",
            "use_time": 0,
            "use_shopping_cart_uuid": "用于订单",
            "use_country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761",
            "is_del": "0",
            "is_active": "0"
        }
    ]
    });

    const fetch_vipcard_list_body = new FormData();


    fetch_vipcard_list_body.append('id', fetch_vipcard_list_select_info.value1);

    fetch_vipcard_list_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_vipcard_list_body.append('time', String(fetch_vipcard_list_select_info.time));

    fetch_vipcard_list_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/vipcard/fetch/fetch_vipcard_list.php', {


                method: 'POST',
                body: fetch_vipcard_list_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_vipcard_list(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_vipcard_list_select_log.message!==''){

            data_async();
            setfetch_vipcard_list_select_log({message:'',value:'',time:0})
        }
    }, [fetch_vipcard_list_select_log]);

    const [add_vipcard_modal_open, setadd_vipcard_modal_open] = useState(false)

    const [add_vipcard_select_info, setadd_vipcard_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_vipcard_select_log, setadd_vipcard_select_log] = useState({message: '', value: '', time: 0})
    const add_vipcard = (e1: any) => {

        setadd_vipcard_select_log({message: 'click', value: '', time: data_time})

        setadd_vipcard_modal_open(true);

        setadd_vipcard_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_vipcard_modal_oncancel = () => {

        setadd_vipcard_modal_open(false);
    }


    const [add_vipcard_modal_form]=Form.useForm();

    const add_vipcard_modal_initialValues={

        vip_type:'vip',vipday:'5',fetch_method:'cdk'

    }

    const [add_vipcard_modal_onfinish_select_log,setadd_vipcard_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [add_vipcard_modal_onfinish_select_info,setadd_vipcard_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const add_vipcard_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setadd_vipcard_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setadd_vipcard_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_add_vipcard,setreturn_data_add_vipcard]=useState({});

    const add_vipcard_body = new FormData();


    add_vipcard_body.append('finish_data', JSON.stringify(add_vipcard_modal_onfinish_select_info.value1));

    add_vipcard_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_vipcard_body.append('time', String(add_vipcard_modal_onfinish_select_info.time));

    add_vipcard_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/vipcard/insert/insert_vipcard.php', {


                method: 'POST',
                body: add_vipcard_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();
                    setfetch_vipcard_list_select_log({message:'1',value:'',time:data_time})
                    setadd_vipcard_modal_open(false)

                    setreturn_data_add_vipcard(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(add_vipcard_modal_onfinish_select_log.message!==''){

            data_async();
            setadd_vipcard_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [add_vipcard_modal_onfinish_select_log]);




    return (
    <div>

        <FloatButton icon={<PlusOutlined/>} tooltip="新增 VIP 卡" onClick={add_vipcard}/>
<Tabs items={[{key:'1',label:'已使用',children:<div>


        {return_data_fetch_vipcard_list.message!==2000?<div></div>:<div>

            {return_data_fetch_vipcard_list.info.map(item1=>(<Card><div style={{display:'flex',flexDirection:'column'}}><label>会员信息：{item1.name}</label>


                <label>会员状态：{item1.status}</label>

                <label>key有效期：{item1.card_start_time} - {item1.card_end_time}</label>
                <label>key使用时间：{dayjs.unix(item1.use_time).format('YYYY-MM-DD HH:mm:ss')}</label>

                <label>key值：{item1.key_cdk}</label>

            </div></Card>))}</div>}


    </div>}]}>


</Tabs>





        <Modal open={add_vipcard_modal_open} onCancel={setadd_vipcard_modal_oncancel} footer={null} title={'创建cdk'}>




            <Form form={add_vipcard_modal_form} initialValues={add_vipcard_modal_initialValues} onFinish={add_vipcard_modal_onfinish}>

                <label>vip_type</label>

                <Form.Item name={'vip_type'} rules={[{message:'必填项',required:true}]}>

                    <Select options={[{value:'vip',label:'vip'},{value:'svip',label:'svip'}]}>



                    </Select>


                </Form.Item>

                <label>vipday</label>

                <Form.Item name={'vipday'} rules={[{message:'必填项',required:true}]}>

                    <Select options={[{value:'5',label:'5'},{value:'30',label:'30'},{value:'60',label:'60'},{value:'90',label:'90'},{value:'180',label:'180'},{value:'365',label:'365'}]}>



                    </Select>

                </Form.Item>




            {/*    <label>key_cdk</label>

                <Form.Item name={'key_cdk'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>
*/}



        {/*        <label>card_start_time</label>

                <Form.Item name={'card_start_time'} rules={[{message:'必填项',required:true}]}>

                    <DatePicker format={'YYYY-MM-DD'} />

                </Form.Item>*/}

                <label>card_timeRange_time</label>

                <Form.Item name={'card_timeRange_time'} rules={[{message:'必填项',required:true}]}>

                    <RangePicker placement={'bottomLeft'} />
                </Form.Item>


                <label>fetch_method</label>

                <Form.Item name={'fetch_method'} rules={[{message:'必填项',required:true}]}>

                    <Select options={[{value:'cdk',label:'cdk'}]}>



                    </Select>

                </Form.Item>





                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setadd_vipcard_modal_oncancel}>取消</Button>

            </Form>


        </Modal>



    </div>
  )
}
export default Project_vipcard;
